module.exports = __webpack_public_path__ + "static/8ba81508b4e46a459d3fd1f6a7a11fa9.png";